var _path, _path2, _mask, _g, _ellipse;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMotionMobile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 144,
    height: 244,
    viewBox: "0 0 144 244",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M72 142.669C32.2972 142.669 0 110.67 0 71.3343C0 31.9985 32.2972 0 72 0C111.703 0 144 31.9985 144 71.3343C144 110.67 111.703 142.669 72 142.669ZM72 40.7625C54.9257 40.7625 41.1429 54.4179 41.1429 71.3343C41.1429 88.2508 54.9257 101.906 72 101.906C89.0743 101.906 102.857 88.2508 102.857 71.3343C102.857 54.4179 88.8686 40.7625 72 40.7625Z",
    fill: "#FFCC00"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M72 244C32.2972 244 0 212.114 0 172.917C0 133.72 32.2972 101.835 72 101.835C111.703 101.835 144 133.72 144 172.917C144 212.114 111.703 244 72 244ZM72 142.453C54.9257 142.453 41.1429 156.061 41.1429 172.917C41.1429 189.774 54.9257 203.381 72 203.381C89.0743 203.381 102.857 189.774 102.857 172.917C102.857 156.061 88.8686 142.453 72 142.453Z",
    fill: "#3098F3"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "mask0",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 101,
    width: 144,
    height: 143
  }, /*#__PURE__*/React.createElement("path", {
    d: "M71.9288 243.997C32.2652 243.997 0 212.09 0 172.866C0 133.643 32.2652 101.735 71.9288 101.735C111.592 101.735 143.858 133.643 143.858 172.866C143.858 212.09 111.592 243.997 71.9288 243.997ZM71.9288 142.382C54.8714 142.382 41.1021 155.998 41.1021 172.866C41.1021 189.735 54.8714 203.351 71.9288 203.351C88.9862 203.351 102.755 189.735 102.755 172.866C102.755 155.998 88.7806 142.382 71.9288 142.382Z",
    fill: "#D9D9DA"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M71.9288 142.494C32.2652 142.494 0 110.586 0 71.3625C0 32.1388 32.2652 0.231445 71.9288 0.231445C111.592 0.231445 143.858 32.1388 143.858 71.3625C143.858 110.586 111.592 142.494 71.9288 142.494ZM71.9288 40.8778C54.8714 40.8778 41.1021 54.4943 41.1021 71.3625C41.1021 88.2307 54.8714 101.847 71.9288 101.847C88.9862 101.847 102.755 88.2307 102.755 71.3625C102.755 54.4943 88.7806 40.8778 71.9288 40.8778Z",
    fill: "#082C4E"
  }))), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 118.139,
    cy: 194.846,
    rx: 20.2817,
    ry: 19.9131,
    fill: "#082C4E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMotionMobile);
export default __webpack_public_path__ + "static/media/motion-mobile.414d55db4cccf4fb4818a2806d450788.svg";
export { ForwardRef as ReactComponent };